/*
 * ldy-catalogo — la scelta della protezione nella pagina di una collezione (sections/ldy-catalogo.liquid).
 * Un tocco su un livello mostra solo i capi di quel livello (data-livello sulle carte), scrive la frase del
 * livello sotto i riquadri e mette #livello-N nell'indirizzo (senza saltare). Un secondo tocco sullo stesso
 * livello torna a tutti i capi (27/10/2026: tolto «Vedi tutti i … modelli», sua richiesta).
 * All'apertura e quando cambia l'indirizzo (link con #livello-N) sceglie quel livello.
 */
class LdyCatalogo extends HTMLElement {
  connectedCallback() {
    this.attuale = '0';
    this.segmenti = [...this.querySelectorAll('[data-livello-scelta]')];
    this.carte = [...this.querySelectorAll('[data-livello]')];
    this.frase = this.querySelector('[data-frase-livello]');
    this.alClic = (evento) => {
      const segmento = evento.target.closest('[data-livello-scelta]');
      if (!segmento) return;
      const livello = segmento.dataset.livelloScelta;
      this.scegli(livello === this.attuale ? '0' : livello, true);
    };
    this.daIndirizzo = () => {
      const trovato = location.hash.match(/^#livello-(\d)$/);
      if (trovato && this.segmenti.some((s) => s.dataset.livelloScelta === trovato[1])) {
        this.scegli(trovato[1], false);
      }
    };
    this.addEventListener('click', this.alClic);
    window.addEventListener('hashchange', this.daIndirizzo);
    this.daIndirizzo();
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.alClic);
    window.removeEventListener('hashchange', this.daIndirizzo);
  }

  scegli(livello, daTocco) {
    this.attuale = livello;
    let scelto = null;
    for (const segmento of this.segmenti) {
      const si = segmento.dataset.livelloScelta === livello;
      segmento.setAttribute('aria-pressed', String(si));
      if (si) scelto = segmento;
    }
    for (const carta of this.carte) {
      carta.hidden = livello !== '0' && carta.dataset.livello !== livello;
    }
    if (this.frase) {
      this.frase.textContent = scelto ? scelto.dataset.spiega || '' : this.frase.dataset.fraseTutti || '';
      this.frase.hidden = !this.frase.textContent;
    }
    if (daTocco) {
      const indirizzo = livello === '0' ? location.pathname + location.search : `#livello-${livello}`;
      history.replaceState(history.state, '', indirizzo);
    }
  }
}

if (!customElements.get('ldy-catalogo')) customElements.define('ldy-catalogo', LdyCatalogo);
